var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _class, _temp, _initialiseProps;

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

import React, { Component } from 'react';
import t from 'prop-types';
import { is_touch_device } from '../util';

var validarNumPagina = function validarNumPagina(numPagina, incremento, primeraPagina, ultimaPagina, numPaginaPrevioAEdicion) {
  var num = Number(numPagina);

  if (isNaN(num)) {
    return numPaginaPrevioAEdicion;
  }

  if (incremento === 2) {
    if (num % 2 !== primeraPagina % 2) {
      return num > primeraPagina ? validarNumPagina(num - 1, incremento, primeraPagina, ultimaPagina, numPaginaPrevioAEdicion) : primeraPagina;
    }
  }

  var ultimaPaginaPermitida = ultimaPagina - incremento + 1;

  if (num >= ultimaPaginaPermitida) {
    return ultimaPaginaPermitida;
  }

  if (num < primeraPagina) {
    return primeraPagina;
  }

  return num;
};

var Paginacion = (_temp = _class = function (_Component) {
  _inherits(Paginacion, _Component);

  function Paginacion(props) {
    _classCallCheck(this, Paginacion);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props));

    _initialiseProps.call(_this);

    var numPagina = validarNumPagina(props.numPagina, props.incremento, props.primeraPagina, props.ultimaPagina, props.numPagina);
    _this.state = {
      numPagina: numPagina,
      numPaginaPrevioAEdicion: numPagina,
      editando: false
    };
    _this.numPaginaInputRef = React.createRef();
    return _this;
  } // static getDerivedStateFromProps = (props, state) => {
  //     const {numPagina, primeraPagina, ultimaPagina, separador, incremento} = props
  //     const numPaginaValido = validarNumPagina(numPagina, incremento, primeraPagina, ultimaPagina)
  //     // const value = construirTextoPaginacion({numPagina: numPaginaValido, ultimaPagina, separador, incremento})
  //     if (numPagina === state.numPagina ) {
  //         return null
  //     }
  //     return ({
  //         numPagina: numPaginaValido,
  //         // value
  //     });
  // }


  Paginacion.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState) {
    var _props = this.props,
        incremento = _props.incremento,
        primeraPagina = _props.primeraPagina,
        ultimaPagina = _props.ultimaPagina,
        numPagina = _props.numPagina;

    if (prevProps.primeraPagina !== primeraPagina || prevProps.ultimaPagina !== ultimaPagina || prevProps.numPagina !== numPagina) {
      // this.handleIrAPagina(this.props.numPagina)
      var numPaginaPrevioAEdicion = this.state.numPaginaPrevioAEdicion;
      var numPaginaValido = validarNumPagina(numPagina, incremento, primeraPagina, ultimaPagina, numPaginaPrevioAEdicion);
      this.setState({
        numPagina: numPaginaValido,
        editando: false
      });
    } // const {numPagina, primeraPagina, ultimaPagina, incremento} = this.props
    // const numPaginaValido = validarNumPagina(numPagina, incremento, primeraPagina, ultimaPagina)
    // if (numPaginaValido !== this.state.numPagina) {
    //     this.setState({numPagina: numPaginaValido})
    // }

  };

  Paginacion.prototype.render = function render() {
    var _state = this.state,
        numPagina = _state.numPagina,
        editando = _state.editando;
    var propsPaginaPrevia = {};
    var classNamesPaginaPrevia = ['paginaPrevia'];
    var eventName = is_touch_device() ? 'onTouchEnd' : 'onClick';

    if (this.paginaPreviaDisponible() && !editando) {
      propsPaginaPrevia[eventName] = this.handleIrAPaginaAnterior;
    } else {
      classNamesPaginaPrevia.push('desactivado');
    }

    var propsPaginaSiguiente = {};
    var classNamesPaginaSiguiente = ['paginaSiguiente'];

    if (this.paginaSiguienteDisponible() && !editando) {
      propsPaginaSiguiente[eventName] = this.handleIrAPaginaSiguiente;
    } else {
      classNamesPaginaSiguiente.push('desactivado');
    }

    return React.createElement('div', {
      className: 'paginacion'
    }, React.createElement('div', _extends({
      className: classNamesPaginaPrevia.join(' ')
    }, propsPaginaPrevia)), React.createElement('form', {
      onSubmit: this.handleSubmit
    }, editando && React.createElement('input', {
      ref: this.numPaginaInputRef,
      type: 'text',
      className: 'inputPaginacion',
      value: numPagina,
      onChange: this.handleChange,
      onBlur: this.handleBlur
    }), !editando && React.createElement('input', {
      type: 'text',
      className: 'inputPaginacion',
      value: this.construirTextoPaginacion(),
      onClick: this.handleEditar,
      readOnly: true
    })), React.createElement('div', _extends({
      className: classNamesPaginaSiguiente.join(' ')
    }, propsPaginaSiguiente)));
  };

  return Paginacion;
}(Component), _class.defaultProps = {
  incremento: 1,
  primeraPagina: 1,
  numPagina: 1,
  ultimaPagina: 10,
  separador: ' of '
}, _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.construirTextoPaginacion = function () {
    var _props2 = _this2.props,
        ultimaPagina = _props2.ultimaPagina,
        separador = _props2.separador,
        incremento = _props2.incremento;
    var numPagina = _this2.state.numPagina;

    if (incremento === 2) {
      return numPagina + ' - ' + (numPagina + 1) + separador + ultimaPagina;
    }

    return '' + numPagina + separador + ultimaPagina;
  };

  this.handleIrAPagina = function (numPaginaDestino) {
    var _props3 = _this2.props,
        incremento = _props3.incremento,
        primeraPagina = _props3.primeraPagina,
        ultimaPagina = _props3.ultimaPagina,
        onPagina = _props3.onPagina;
    var numPaginaPrevioAEdicion = _this2.state.numPaginaPrevioAEdicion;
    var numPaginaValido = validarNumPagina(numPaginaDestino, incremento, primeraPagina, ultimaPagina, numPaginaPrevioAEdicion);

    _this2.setState({
      numPagina: numPaginaValido,
      editando: false
    }, function () {
      return onPagina(numPaginaValido);
    });
  };

  this.handleEditar = function () {
    _this2.setState({
      numPaginaPrevioAEdicion: _this2.state.numPagina,
      editando: true
    }, function () {
      var input = _this2.numPaginaInputRef.current;
      input.setSelectionRange(0, input.value.length);
      input.focus();
    });
  };

  this.handleChange = function (event) {
    _this2.setState({
      numPagina: event.target.value
    });
  };

  this.handleBlur = function (event) {
    event.preventDefault();

    _this2.handleIrAPagina(_this2.state.numPaginaPrevioAEdicion);
  };

  this.handleSubmit = function (event) {
    event.preventDefault();

    _this2.handleIrAPagina(_this2.state.numPagina);
  };

  this.handleIrAPaginaAnterior = function (e) {
    e.preventDefault();

    _this2.handleIrAPagina(_this2.state.numPagina - _this2.props.incremento);
  };

  this.handleIrAPaginaSiguiente = function (e) {
    e.preventDefault();

    _this2.handleIrAPagina(_this2.state.numPagina + _this2.props.incremento);
  };

  this.paginaPreviaDisponible = function () {
    return _this2.state.numPagina > _this2.props.primeraPagina;
  };

  this.paginaSiguienteDisponible = function () {
    var _props4 = _this2.props,
        incremento = _props4.incremento,
        ultimaPagina = _props4.ultimaPagina;
    return _this2.state.numPagina + incremento <= ultimaPagina; // ultimaPagina() ;
  };
}, _temp);
Paginacion.propTypes = process.env.NODE_ENV !== "production" ? {
  incremento: t.oneOf([1, 2]),

  /** número minimo de pagina */
  primeraPagina: t.number,

  /** número pagina inicial */
  numPagina: t.number,

  /** número maximo de pagina */
  ultimaPagina: t.number,

  /** separador */
  separador: t.string,

  /** 
   * Evento informando que se quiere ir a un numero de pagina. 
   * Es una funcion de la forma: <br />
   * <code>(numPagina) => { ... }</code>
   */
  onPagina: t.func.isRequired
} : {};
export default Paginacion;